import { AlertaSuporteDecisaoClinica } from 'hooks/sdc/model-sdc'

import {
  AlertasSdcRiscoCardiovascularEnum,
  EstratificacaoRastreamentoEnum,
  RastreamentosIdentificadoPorEnum,
  RastreamentosModel,
  RastreamentosTooltipIdentificadoPorEnum,
  RastreamentosTypesEnum,
} from './model-rastreamentos'

const RASTREAMENTO_MUITO_ALTO_RISCO_CARDIOVASCULAR: RastreamentosModel = {
  id: AlertasSdcRiscoCardiovascularEnum.MUITO_ALTO_RISCO,
  titulo: RastreamentosTypesEnum.RISCO_CARDIOVASCULAR,
  estratificacao: EstratificacaoRastreamentoEnum.MUITO_ALTO_RISCO,
  identificadoPor: RastreamentosIdentificadoPorEnum.SDC,
  tooltipText: RastreamentosTooltipIdentificadoPorEnum.SDC,
}

const RASTREAMENTO_ALTO_RISCO_CARDIOVASCULAR: RastreamentosModel = {
  id: AlertasSdcRiscoCardiovascularEnum.ALTO_RISCO,
  titulo: RastreamentosTypesEnum.RISCO_CARDIOVASCULAR,
  estratificacao: EstratificacaoRastreamentoEnum.ALTO_RISCO,
  identificadoPor: RastreamentosIdentificadoPorEnum.SDC,
  tooltipText: RastreamentosTooltipIdentificadoPorEnum.SDC,
}

export function convertAlertasSdcToRastreamentosModel(alertas: AlertaSuporteDecisaoClinica[]): RastreamentosModel[] {
  const alertasSdc = alertas ?? []

  const hasMuitoAltoRisco = alertasSdc.some(
    (alerta) => alerta.id === AlertasSdcRiscoCardiovascularEnum.MUITO_ALTO_RISCO
  )
  if (hasMuitoAltoRisco) {
    return [RASTREAMENTO_MUITO_ALTO_RISCO_CARDIOVASCULAR]
  }

  const hasAltoRisco = alertasSdc.some((alerta) => alerta.id === AlertasSdcRiscoCardiovascularEnum.ALTO_RISCO)
  if (hasAltoRisco) {
    return [RASTREAMENTO_ALTO_RISCO_CARDIOVASCULAR]
  }

  return []
}
